module.exports = __webpack_public_path__ + "static/media/21-7.18abfd97.mp3";